<p-toast />
<p-confirmDialog />

<p-table
  #table
  stripedRows
  [value]="users()"
  [columns]="cols"
  dataKey="id"
  [totalRecords]="totalRecords()"
  [rows]="10"
  [rowsPerPageOptions]="[10, 25, 50, 100]"
  [loading]="isLoading()"
  [paginator]="true"
  [scrollable]="true"
  scrollHeight="flex"
  [tableStyle]="{ 'min-width': '75rem' }"
  sortMode="multiple"
  [lazy]="true"
  (onLazyLoad)="loadData($event)"
  [globalFilterFields]="filterFields"
  editMode="row"
>
  <ng-template #caption>
    <div class="flex flex-wrap items-center justify-end gap-2">
      <ng-content select="[userTableActions]" />
      <p-button
        [label]="'label.addUser' | translate"
        icon="fa fa-plus"
        (click)="showUserPopup()"
      />
    </div>
    <div class="flex flex-wrap items-center justify-end gap-2 mt-2">
      @for (quickFilter of quickFilters(); track quickFilter.key) {
        <p-togglebutton
          [ngModel]="activeQuickFilters().includes(quickFilter.key)"
          (ngModelChange)="toggleQuickFilter(table, quickFilter.key)"
          [onLabel]="quickFilter.label | translate"
          [offLabel]="quickFilter.label | translate"
        />
      }
      <p-button
        [text]="true"
        icon="fa fa-filter-slash"
        [pTooltip]="'label.clearFilter' | translate"
        tooltipPosition="top"
        (click)="clear(table)"
      />
      <p-iconfield iconPosition="left" class="">
        <p-inputicon>
          <i class="fa fa-search"></i>
        </p-inputicon>
        <input
          pInputText
          type="text"
          (input)="onGlobalFilter(table, $event)"
          [placeholder]="'label.search' | translate"
        />
      </p-iconfield>
    </div>
    @if (activeFilters().length) {
      <div class="flex flex-wrap gap-2 mt-2">
        @for (filter of activeFilters(); track filter.field) {
          <p-chip
            [label]="filter.label + ': ' + filter.value"
            [removable]="true"
            (onRemove)="removeFilter(table, filter.field)"
          />
        }
      </div>
    }
  </ng-template>
  <ng-template #header let-columns>
    <tr>
      @for (column of columns; track $index) {
        <th
          [style]="column.style"
          [pSortableColumn]="column.sortField || column.field"
          pResizableColumn
        >
          <div class="min-w-max">
            {{ column.header | translate }}
            @if (column.sortField) {
              <p-sortIcon [field]="column.sortField" />
            }
            @if (column.filterField) {
              @if (column.matchMode === 'in') {
                <p-columnFilter
                  [field]="column.filterField"
                  matchMode="in"
                  display="menu"
                  [showOperator]="column.showOperator || false"
                  [showMatchModes]="column.showMatchModes || false"
                  [showAddButton]="column.showAddButton || false"
                >
                  <ng-template #filter let-value let-filter="filterCallback">
                    @if (groupedSelectOptions()[column.field]; as groupedOpts) {
                      <p-multiselect
                        [ngModel]="value"
                        [options]="groupedOpts"
                        [group]="true"
                        optionLabel="label"
                        optionValue="value"
                        optionGroupLabel="label"
                        optionGroupChildren="items"
                        [placeholder]="
                          column.placeholder
                            ? (column.placeholder | translate)
                            : ('placeholder.selectAll' | translate)
                        "
                        (onChange)="filter($event.value)"
                        [maxSelectedLabels]="1"
                        [filter]="true"
                        class="w-full"
                        appendTo="body"
                      />
                    } @else {
                      <p-multiselect
                        [ngModel]="value"
                        [options]="
                          selectOptions()[column.field] ||
                          filterOptions()[column.field]
                        "
                        [placeholder]="
                          column.placeholder
                            ? (column.placeholder | translate)
                            : ('placeholder.selectAll' | translate)
                        "
                        (onChange)="filter($event.value)"
                        optionLabel="label"
                        optionValue="value"
                        [maxSelectedLabels]="1"
                        [filter]="true"
                        class="w-full"
                        appendTo="body"
                      />
                    }
                  </ng-template>
                </p-columnFilter>
              } @else {
                <p-columnFilter
                  [field]="column.filterField"
                  display="menu"
                  [type]="column.type"
                  [matchMode]="column.matchMode"
                  [showOperator]="column.showOperator || false"
                  [showMatchModes]="column.showMatchModes || false"
                  [showAddButton]="column.showAddButton || false"
                ></p-columnFilter>
              }
            }
          </div>
        </th>
      }
      <th pFrozenColumn alignFrozen="right"></th>
    </tr>
  </ng-template>
  <ng-template #body let-user let-columns="columns">
    <tr>
      @for (column of columns; track $index) {
        @switch (column.displayType ?? column.type) {
          @case ('text') {
            <td>
              <p-cellEditor>
                <ng-template #input>
                  <input
                    pInputText
                    type="text"
                    [(ngModel)]="user[column.field]"
                    required
                  />
                </ng-template>
                <ng-template #output>
                  {{ user[column.field] }}
                </ng-template>
              </p-cellEditor>
            </td>
          }
          @case ('tags') {
            <td>
              <p-cellEditor>
                <ng-template #input>
                  @if (groupedSelectOptions()[column.field]; as groupedOpts) {
                    <p-multiselect
                      [options]="groupedOpts"
                      [(ngModel)]="user[column.field]"
                      [group]="true"
                      optionLabel="label"
                      optionValue="value"
                      optionGroupLabel="label"
                      optionGroupChildren="items"
                      [placeholder]="
                        column.placeholder
                          ? (column.placeholder | translate)
                          : undefined
                      "
                      display="chip"
                      [filter]="true"
                      class="w-full @3xl:w-80"
                      appendTo="body"
                    />
                  } @else {
                    @if (selectOptions()[column.field]; as opts) {
                      <p-multiselect
                        [options]="opts"
                        [(ngModel)]="user[column.field]"
                        optionLabel="label"
                        optionValue="value"
                        [placeholder]="
                          column.placeholder
                            ? (column.placeholder | translate)
                            : undefined
                        "
                        display="chip"
                        [filter]="true"
                        class="w-full @3xl:w-80"
                        appendTo="body"
                      />
                    } @else {
                      <p-multiselect
                        [options]="
                          tagOptions()[column.field] || column.textOptions || []
                        "
                        [(ngModel)]="user[column.field]"
                        [placeholder]="
                          column.placeholder
                            ? (column.placeholder | translate)
                            : undefined
                        "
                        display="chip"
                        class="w-full @3xl:w-80"
                        appendTo="body"
                      />
                    }
                  }
                </ng-template>
                <ng-template #output>
                  <div class="w-full @3xl:w-80 flex flex-wrap">
                    @if (selectOptions()[column.field]; as opts) {
                      @for (id of user[column.field]; track $index) {
                        <p-tag
                          [value]="(opts | resolveLabel: id) || id"
                          severity="success"
                          styleClass="m-1"
                        />
                      }
                    } @else {
                      @for (tag of user[column.field]; track $index) {
                        <p-tag
                          [value]="('' + tag).toLowerCase()"
                          severity="success"
                          styleClass="m-1"
                        />
                      }
                    }
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>
          }
          @case ('boolean') {
            <td class="text-center">
              <p-cellEditor>
                <ng-template #input>
                  <p-toggleswitch [(ngModel)]="user[column.field]" />
                </ng-template>
                <ng-template #output>
                  <i
                    class="text-2xl fa"
                    [ngClass]="{
                      'text-lime-500 fa-check-circle': user[column.field],
                      'text-red-500 fa-times-circle': !user[column.field],
                    }"
                  ></i>
                </ng-template>
              </p-cellEditor>
            </td>
          }
          @case ('date') {
            <td>
              <p-cellEditor>
                <ng-template #input>
                  <p-datepicker
                    [(ngModel)]="user[column.field]"
                    [showIcon]="true"
                    dateFormat="dd.mm.yy"
                    class="w-full"
                    appendTo="body"
                  />
                </ng-template>
                <ng-template #output>
                  {{ user[column.field] | date: 'dd.MM.yyyy' }}
                </ng-template>
              </p-cellEditor>
            </td>
          }
          @case ('progress') {
            <td>
              <p-progressbar [value]="user[column.field] * 100" />
            </td>
          }
          @default {
            <td>{{ user[column.field] }}</td>
          }
        }
      }
      <td pFrozenColumn alignFrozen="right">
        <div class="flex items-center justify-center gap-2">
          @if (!userPopupVisible) {
            <p-button
              type="button"
              icon="fa fa-pencil"
              (click)="onRowEditInit(user)"
              text
              rounded
              size="small"
              severity="secondary"
            />
            @if (showManageUserFields()) {
              <p-button
                type="button"
                icon="fa fa-list-check"
                [pTooltip]="'label.manageUserFields' | translate"
                tooltipPosition="top"
                (click)="onManageUserFields(user)"
                text
                rounded
                size="small"
                severity="secondary"
              />
            }
          }
          @if (!user['hasPassword']) {
            <p-button
              type="button"
              icon="fa fa-envelope"
              [pTooltip]="'label.sendOnboardingMail' | translate"
              tooltipPosition="top"
              (click)="onSendOnboardingMail(user)"
              text
              rounded
              size="small"
              severity="info"
            />
          }
          <p-button
            type="button"
            icon="fa fa-trash"
            (click)="onRowDeleteInit($event, user)"
            text
            rounded
            size="small"
            severity="secondary"
          />
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template #emptymessage>
    <tr>
      <td colspan="9">{{ 'message.noUserData' | translate }}</td>
    </tr>
  </ng-template>
</p-table>

<p-dialog
  [header]="
    currentUser ? ('user.edit' | translate) : ('user.create' | translate)
  "
  [modal]="true"
  [(visible)]="userPopupVisible"
  styleClass="w-[90vw] max-w-4xl"
>
  <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
    <div class="grid grid-cols-1 @3xl:grid-cols-2 gap-4 mb-4">
      @for (field of formFields; track field.field) {
        <div class="flex flex-col gap-2">
          <label class="w-fit" [attr.for]="field.field">
            {{ field.header | translate }}
            @if (field.required) {
              *
            }
          </label>
          @switch (field.type) {
            @case ('date') {
              <p-datepicker
                [inputId]="field.field"
                [formControlName]="field.field"
                [showIcon]="true"
                dateFormat="dd.mm.yy"
                appendTo="body"
              />
            }
            @case ('select') {
              <p-select
                [inputId]="field.field"
                [formControlName]="field.field"
                [options]="field.options || []"
                optionLabel="label"
                optionValue="value"
                [filter]="field.filter ?? false"
                [showClear]="true"
                appendTo="body"
                class="w-full"
              >
                <ng-template let-item #item>
                  {{ item.label | translate }}
                </ng-template>
                <ng-template let-item #selectedItem>
                  {{ item.label | translate }}
                </ng-template>
              </p-select>
            }
            @case ('boolean') {
              <p-toggleswitch
                [inputId]="field.field"
                [formControlName]="field.field"
              />
            }
            @case ('tags') {
              @if (groupedSelectOptions()[field.field]; as groupedOpts) {
                <p-multiselect
                  [inputId]="field.field"
                  [formControlName]="field.field"
                  [options]="groupedOpts"
                  [group]="true"
                  optionLabel="label"
                  optionValue="value"
                  optionGroupLabel="label"
                  optionGroupChildren="items"
                  display="chip"
                  [filter]="true"
                  class="w-full"
                  appendTo="body"
                />
              } @else {
                @if (selectOptions()[field.field]; as opts) {
                  <p-multiselect
                    [inputId]="field.field"
                    [formControlName]="field.field"
                    [options]="opts"
                    optionLabel="label"
                    optionValue="value"
                    display="chip"
                    [filter]="true"
                    class="w-full"
                    appendTo="body"
                  />
                } @else {
                  <p-multiselect
                    [inputId]="field.field"
                    [formControlName]="field.field"
                    [options]="
                      tagOptions()[field.field] || field.textOptions || []
                    "
                    display="chip"
                    class="w-full"
                    appendTo="body"
                  />
                }
              }
            }
            @default {
              <input
                pInputText
                [id]="field.field"
                type="text"
                [formControlName]="field.field"
              />
            }
          }
        </div>
      }
    </div>

    <div class="flex justify-end gap-2">
      <p-button
        [label]="'label.cancel' | translate"
        severity="secondary"
        (click)="closeUserPopup()"
      />
      <p-button [label]="'label.save' | translate" type="submit" />
    </div>
  </form>
</p-dialog>
